import styles from '../globals/pages.module.scss'
import ClaimFormMbFinanceCheck from '../components/claimFormMbFinanceCheck/main'

function MakeClaimmbFinanceCheck() {
    return (
        <div className={`${styles.pcpClaimFormContainer}`}>
            <ClaimFormMbFinanceCheck />
        </div>
    )
}

export default MakeClaimmbFinanceCheck
